import {$} from '../jquery-definition.js';
import {CountUp} from 'countup.js';

$( function() {
	countUp();
} );

let isCounting = false;

$( window ).scroll( function() {
	if ( !isCounting ) {
		isCounting = true;
		setTimeout( function() {
			countUp();
			isCounting = false;
		}, 100 ); // Adjust timeout as needed
	}
} );

function countUp() {
	$('.counter').each(function () {
		const $this = $(this);

		// Get data attributes and ensure they are defined
		const value = $this.attr('data-end-value');
		const start = $this.attr('data-start-value') || 0; // Default start to 0 if missing
		const prefix = $this.attr('data-prefix') || '';
		const suffix = $this.attr('data-suffix') || '';
		const separator = $this.attr('data-separator') || '';
		const decimalPlaces = parseInt($this.attr('data-decimal-places')) || 0;

		// Only proceed if `value` is defined
		if (typeof value === 'undefined') {
			console.warn('data-end-value attribute is missing on element:', $this);
			return;
		}

		const countOptions = {
			separator: separator,
			decimal: ',',
			duration: 2,
			startVal: parseFloat(start),
			prefix: prefix,
			suffix: suffix,
			decimalPlaces: decimalPlaces,
		};

		// Check if the element is in the viewport and has not been counted yet
		if ($this.is(':in-viewport') && !$this.hasClass('counted')) {
			let count;

			if ($this.hasClass('count-integer')) {
				count = new CountUp($this[0], parseInt(value), countOptions);
			} else if ($this.hasClass('count-float')) {
				count = new CountUp($this[0], parseFloat(value), countOptions);
			}

			// Check if count is successfully initialized before calling `count.start()`
			if (count && !count.error) {
				count.start();
				$this.addClass('counted');
			} else {
				console.error('CountUp initialization error:', count ? count.error : 'undefined CountUp instance');
			}
		}
	});
}

